import { Box, BoxProps } from "@chakra-ui/react";

function ResourceImage({
  color = "#0D0D0D",
  ...props
}: BoxProps & { color?: string }) {
  return (
    <Box {...props}>
      <svg
        width="56"
        height="57"
        viewBox="0 0 56 57"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          y="0.5"
          width="56"
          height="56"
          rx="8.4"
          fill="#0073E0"
          fill-opacity="0.06"
        />
        <path
          d="M12.4165 24.8337C12.4165 17.9197 12.4165 14.4628 14.6986 12.3149C16.9808 10.167 20.6538 10.167 27.9998 10.167H29.4165C35.3954 10.167 38.3848 10.167 40.4609 11.6297C41.0557 12.0488 41.5838 12.5458 42.0291 13.1056C43.5832 15.0596 43.5832 17.8731 43.5832 23.5003V28.167C43.5832 33.5995 43.5832 36.3157 42.7235 38.4851C41.3413 41.9727 38.4184 44.7237 34.7128 46.0245C32.4079 46.8337 29.5218 46.8337 23.7498 46.8337C20.4515 46.8337 18.8024 46.8337 17.4853 46.3713C15.3678 45.628 13.6975 44.056 12.9078 42.0631C12.4165 40.8234 12.4165 39.2713 12.4165 36.167V24.8337Z"
          stroke="#0073E0"
          stroke-width="2.75"
          stroke-linejoin="round"
        />
        <path
          d="M43.5832 28.5C43.5832 31.8751 40.8472 34.6111 37.4721 34.6111C36.2515 34.6111 34.8125 34.3972 33.6257 34.7152C32.5713 34.9978 31.7476 35.8214 31.4651 36.8758C31.1471 38.0626 31.361 39.5016 31.361 40.7222C31.361 44.0973 28.625 46.8333 25.2499 46.8333"
          stroke="#0073E0"
          stroke-width="2.75"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.6665 19.333H33.4998"
          stroke="#0073E0"
          stroke-width="2.75"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.6665 26.667H26.1665"
          stroke="#0073E0"
          stroke-width="2.75"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </Box>
  );
}

export { ResourceImage };
